const applied = [
  {
    path: '/applied/filter',
    component: () => import('@/mobile/page/applied/filter'),
    meta: {
      name: '필터',
    },
  },
  {
    path: '/applied/mealcost',
    component: () => import('@/mobile/page/applied/mealcost'),
    meta: {
      name: '식대비',
    },
  },
  {
    path: '/applied/expense',
    component: () => import('@/mobile/page/applied/expense'),
    meta: {
      name: '지출결의서',
    },
  },
  {
    path: '/applied/businesstrip',
    component: () => import('@/mobile/page/applied/businesstrip'),
    meta: {
      name: '출장결과보고서',
    },
  },
  {
    path: '/applied/holidaywork',
    component: () => import('@/mobile/page/applied/holidaywork'),
    meta: {
      name: '휴일근무',
    },
  },
  {
    path: '/applied/admit',
    component: () => import('@/mobile/page/applied/admit'),
    meta: {
      name: '인정휴가 지급',
    },
  },
  {
    path: '/applied/vacation',
    component: () => import('@/mobile/page/applied/vacation'),
    meta: {
      name: '휴가',
    },
  },
  {
    path: '/applied/workhome',
    component: () => import('@/mobile/page/applied/workhome'),
    meta: {
      name: '재택근무',
    },
  },
  {
    path: '/applied/outside',
    component: () => import('@/mobile/page/applied/outside'),
    meta: {
      name: '출장/외근',
    },
  },
  {
    path: '/applied/submit',
    component: () => import('@/mobile/page/applied/submit'),
    meta: {
      name: '품의서',
    },
  },
];

export default applied;
